import { render, staticRenderFns } from "./NotificationEventSettingsTable.vue?vue&type=template&id=5bf25bc1&scoped=true"
import script from "./NotificationEventSettingsTable.vue?vue&type=script&lang=js"
export * from "./NotificationEventSettingsTable.vue?vue&type=script&lang=js"
import style0 from "./NotificationEventSettingsTable.vue?vue&type=style&index=0&id=5bf25bc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf25bc1",
  null
  
)

export default component.exports